import { render } from "./BaseModalV3.vue?vue&type=template&id=25b30985&scoped=true"
import script from "./BaseModalV3.vue?vue&type=script&lang=js"
export * from "./BaseModalV3.vue?vue&type=script&lang=js"

import "./BaseModalV3.vue?vue&type=style&index=0&id=25b30985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b30985"]])

export default __exports__